<script setup>
import { useI18n } from '../../i18n'
import { systemRoleName } from '../../access/labels.js'

defineProps({ users: { type: Array, required: true }, selectedId: { type: Number, default: null } })
const emit = defineEmits(['select'])
const { t } = useI18n()
</script>

<template>
  <div class="access-user-cards">
    <button v-for="user in users" :key="user.id" type="button" :data-user-id="user.id"
      :class="{ selected: user.id === selectedId }" @click="emit('select', user)">
      <span><strong>{{ user.displayName }}</strong><small>{{ user.username }}</small></span>
      <span class="role-chip">{{ systemRoleName(t, user.role) }}</span>
      <span>{{ user.stationPolicy === 'ALL' ? t('allStations') : t('stationCount', { count: user.stationCount }) }}</span>
      <span class="account-status" :class="user.enabled ? 'enabled' : 'blocked'"><i></i>{{ user.enabled ? t('userActive') : t('userBlocked') }}</span>
    </button>
  </div>
</template>
